import { render, staticRenderFns } from "./APIObjectDBEditor.vue?vue&type=template&id=1dee2ffe&scoped=true"
import script from "./APIObjectDBEditor.vue?vue&type=script&lang=js"
export * from "./APIObjectDBEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dee2ffe",
  null
  
)

export default component.exports